import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    allAccordingToParagraph: [],
    loading: false,
    error: null,
};

const dropdownSlice = createSlice({
    name: 'dropdown',
    initialState,
    reducers: {
        setAllAccordingToParagraph: (state, action) => {
            state.allAccordingToParagraph = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item })) : [];
        },
        setAllMeasurements: (state, action) => {
            state.allMeasurements = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item })) : [];
        },
    },
    extraReducers: (builder) => {
    },
});

export const { setAllAccordingToParagraph, setAllMeasurements } = dropdownSlice.actions;

export default dropdownSlice.reducer;